import RemGalleu from "../../assets/combatants/isekai-league/rem-galleu.png";
import RemGalleuIcon from "../../assets/combatants/isekai-league/rem-galleu-icon.png";
import RemGalleuWin from "../../assets/combatants/isekai-league/rem-galleu-win.png";
import RemGalleuLose from "../../assets/combatants/isekai-league/rem-galleu-lose.png";

export const seriesId = "How NOT to Summon a Demon Lord";

export default {
  remGalleu: {
    seriesId,
    id: 'remGalleu',
    name: "Rem Galleu",
    description:
      "A small Pantherian who became an invoker and had no choice but to become an adventurer and continue to demonstrate her strength, one day hoping to exterminate the Demon King Krebskrem. ",
    img: RemGalleu,
    icon: RemGalleuIcon,
    opWinImg: RemGalleuWin,
    opLoseImg: RemGalleuLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "small",
    eyeColor: "green",
    hairColor: "black",
    skinColor: "fair",
    height: 1,
    penisSize: 0,
    breastSize: 1,
    vaginaSize: 1,
    anusSize: 1,
    throatSize: 1,
    prefAttack: "vagina",
    prefTarget: "cock",
    uniqueAttackText:
      "Like a hungry semen demon, Rem rides xxxx's cock shuddering as it enters her tight pussy.",
    roughPlayLvl: 20,
    seductionResistance: 25,
    grapplingProwess: 15,
    tongueProwess: 25,
    touchProwess: 20,
    cockProwess: 15,
    vaginaProwess: 30,
    anusProwess: 20,
    touchResistance: 25,
    breastResistance: 25,
    mouthResistance: 40,
    cockResistance: 15,
    vaginaResistance: 35,
    anusResistance: 20,
    orgasmLimit: 3,
  },
};
